<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" epub:type="pagebreak" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" epub:type="pagebreak" id="piii" role="doc-pagebreak"></span>The Feeling of Forgetting</h1>
<h1 class="bk1">Christianity, Race, and Violence in America</h1>
<p class="bkau"><span class="sm">JOHN</span> <span class="sm">CORRIGAN</span></p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-corrigan-0003.vue?36cd1064